import cxs from 'cxs';

export const DEFAULT = ({ fullWidth } = {}) => cxs({
  display: 'flex',
  flexDirection: 'column',
  ...(fullWidth && { width: '100%' })
});

export const CONTENT = ({ hideProgressBar } = {}) => cxs({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  paddingTop: hideProgressBar ? '0px' : '125px'
});

export const BACK_BTN = cxs({
  position: 'fixed',
  top: '22px',
  left: '30px',
  zIndex: 3
});